import { render } from "./Iron.vue?vue&type=template&id=4a2ee95a"
import script from "./Iron.vue?vue&type=script&lang=js"
export * from "./Iron.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/productionOverview/Iron.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a2ee95a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a2ee95a', __exports__)) {
    api.reload('4a2ee95a', __exports__)
  }
  
  module.hot.accept("./Iron.vue?vue&type=template&id=4a2ee95a", () => {
    api.rerender('4a2ee95a', render)
  })

}


export default __exports__